import axios from "axios";
import { format } from "date-fns";
import React from "react";
import {
  editThisAndFollowingEvents,
  editThisEvent,
} from "../../../../Calendar/calendarFunctions";
import { baseUrl } from "../../../../assets/Animations";
import "./large-view-multiple-event-warning.css";
const LargeViewMultipleEventWarning = ({
  tryToClosePopup,
  setChangeMultipleEvents,
  event,
  setOpenEvent,
  setAllEvents,
  setEditing,
  socket,
  initialDateTimeRef,
}) => {
  const myToken = localStorage.getItem("token");
  const myHeader = { headers: { Authorization: `Bearer ${myToken}` } };
  const [submittingChoice, setSubmittingChoice] = React.useState(false);

  React.useEffect(() => {
    setSubmittingChoice(false);
  }, [event?.id, event?.dateTime]);

  const closeItAllOut = (boo) => {
    setEditing(boo);
    setChangeMultipleEvents(boo);
  };

  const justOne = async () => {
    if (submittingChoice) {
      return;
    }

    setSubmittingChoice(true);
    await editThisEvent(
      event,
      initialDateTimeRef.current,
      setAllEvents,
      closeItAllOut,
      socket,
      event.teacherName,
      myHeader
    );
    axios.post(`${baseUrl}/slack/${event.school}`, {
      message: `${event.teacherName} rescheduled ${event.studentName} ${
        event.familyName
      }'s lesson from ${format(
        new Date(initialDateTimeRef.current),
        "EEEE MMMM do h:mm a"
      )} to ${format(new Date(event.dateTime), "EEEE MMMM do h:mm a")}`,
    });
  };

  const allOfThem = async () => {
    if (submittingChoice) {
      return;
    }

    setSubmittingChoice(true);
    await editThisAndFollowingEvents(
      event,
      initialDateTimeRef.current,
      setAllEvents,
      closeItAllOut,
      socket,
      event.teacherName,
      myHeader
    );
    axios.post(`${baseUrl}/slack/${event.school}`, {
      message: `${event.teacherName} rescheduled all of ${event.studentName} ${
        event.familyName
      }'s lessons from ${format(
        new Date(initialDateTimeRef.current),
        "EEEE h:mm a"
      )} to ${format(
        new Date(event.dateTime),
        "EEEE h:mm a"
      )} starting ${format(new Date(initialDateTimeRef.current), "MMMM do")}`,
    });
  };

  return (
    <div
      className="teacher-calendar-event-editing__repeat-event__wrapper"
      id="teacher-calendar-event-editing__repeat-event__wrapper"
      onClick={(e) => tryToClosePopup(e.target.id)}
    >
      <div
        className="teacher-calendar-event-editing__repeat-event-options__wrapper"
        id="teacher-calendar-event-editing__repeat-event-options__wrapper"
      >
        <div className="teacher-calendar-event-editing__repeat-event-options">
          <div className="teacher-calendar-event-editing__repeat-event-label">
            This is a repeating event.
          </div>
          <div
            className="teacher-calendar-event-editing__repeat-event-button"
            style={submittingChoice ? { opacity: 0.55, pointerEvents: "none" } : {}}
            onClick={() => justOne()}
          >
            {submittingChoice ? 'Saving...' : 'Save for this event only'}
          </div>
          <div
            className="teacher-calendar-event-editing__repeat-event-button"
            style={submittingChoice ? { opacity: 0.55, pointerEvents: "none" } : {}}
            onClick={() => allOfThem()}
          >
            {submittingChoice ? 'Saving...' : 'Save for this & future events'}
          </div>
        </div>
        <div
          className="teacher-calendar-event-editing__repeat-event-cancel"
          style={submittingChoice ? { opacity: 0.55, pointerEvents: "none" } : {}}
          onClick={() => setChangeMultipleEvents(false)}
        >
          Cancel
        </div>
      </div>
    </div>
  );
};
export default LargeViewMultipleEventWarning;
